import { call } from 'redux-saga/effects';
import { signalingRoomJoined } from 'features/room/actions';
import { sendWaitingUsersJoinedSaga } from 'features/users/sagas/sendWaitingUsersJoinedSaga';

export function* onRoomJoinedWaitingUsersSaga(action: ReturnType<typeof signalingRoomJoined>) {
  const { usersAwaitingEntry = [] } = action.payload;

  if (usersAwaitingEntry.length === 0) {
    return;
  }

  yield call(sendWaitingUsersJoinedSaga, usersAwaitingEntry);
}
